// Türkiye il / ilçe / mahalle verisi — public/geo/ altındaki statik dosyalardan
// LAZY (talep üzerine) yüklenir ve bellekte cache'lenir. Bu dosyalar JS bundle'ına
// GİRMEZ; böylece ~1.8MB'lık mahalle verisi ilk yüklemeyi yavaşlatmaz.
//   /geo/provinces.json        -> [{ code, name }]            (81 il, bir kez)
//   /geo/districts.json        -> { code: [ilçe, ...] }        (20KB, bir kez)
//   /geo/mahalle/<code>.json   -> { ilçe: [mahalle, ...] }     (il başına)

const BASE = `${process.env.PUBLIC_URL || ""}/geo`;

let _provinces = null;
let _districtsMap = null;
const _mahalleByCode = {};

async function _getJson(url) {
  const res = await fetch(url);
  if (!res.ok) throw new Error(`geo fetch failed: ${url} (${res.status})`);
  return res.json();
}

// [{ code, name }] — ada göre TR sıralı.
export async function loadProvinces() {
  if (!_provinces) _provinces = await _getJson(`${BASE}/provinces.json`);
  return _provinces;
}

// Belirli ilin ilçeleri (tüm harita bir kez çekilir, cache'lenir).
export async function loadDistricts(cityCode) {
  if (!cityCode) return [];
  if (!_districtsMap) _districtsMap = await _getJson(`${BASE}/districts.json`);
  return _districtsMap[cityCode] || [];
}

// { ilçe: [mahalle] } — il başına dosya, cache'li.
export async function loadMahalleMap(cityCode) {
  if (!cityCode) return {};
  if (!_mahalleByCode[cityCode]) {
    _mahalleByCode[cityCode] = await _getJson(`${BASE}/mahalle/${cityCode}.json`);
  }
  return _mahalleByCode[cityCode];
}

// Belirli il+ilçenin mahalleleri.
export async function loadMahalle(cityCode, ilce) {
  if (!cityCode || !ilce) return [];
  const map = await loadMahalleMap(cityCode);
  return map[ilce] || [];
}

// İl adından koda (ör. "İzmir" -> "35"). provinces listesi verilmeli.
export function codeByProvinceName(provinces, name) {
  return (provinces.find((p) => p.name === name) || {}).code || "";
}
